import hasPageMeta from '@/mixins/hasPageMeta'

export default {
    mixins: [hasPageMeta],

    computed: {
        computedPageTitle() {
            if (this.$route.query.step) return `${this.pageTitle} Setup - ${this.$route.query.step}`
            return `${this.pageTitle} `
        },

        siteTitle() {
            return this.computedPageTitle
        },

        siteDescription() {
            return 'Our free wedding guest list maker is the best way to manage your guest list. Organize with our online wedding guest planner & wedding guest list tracker now'
        },

        previewImage() {
            return require('@/static/guest-list/Loverly_Preview_GuestList.jpg')
        },

        keywords() {
            return 'free wedding guest list manager'
        },
    },

    data() {
        return {
            pageTitle: 'Free Wedding Guest List Maker: Online Wedding Guest Planner & Tracker',
        }
    },
}
